import { render } from "./GraphDonutWithLabel.vue?vue&type=template&id=7ae5becd&scoped=true&ts=true"
import script from "./GraphDonutWithLabel.vue?vue&type=script&lang=ts"
export * from "./GraphDonutWithLabel.vue?vue&type=script&lang=ts"

import "./GraphDonutWithLabel.vue?vue&type=style&index=0&id=7ae5becd&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ae5becd"]])

export default __exports__